module.exports = __webpack_public_path__ + "static/media/select.1b83f607.svg";